import styled from 'styled-components'

export const LabelDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
`
